import { numberFmt } from "@/util/numberFmt"

import { Label } from "./ui/label"
import { Skeleton } from "./ui/skeleton"

export default function MetricCard({
  value,
  name,
  sub,
  isPending,
  isError,
  currency,
}: {
  value?: number
  name: string
  sub: string
  isPending: boolean
  isError: boolean
  currency?: boolean
}) {
  return (
    <div className="rounded-md shadow-sm p-4 border bg-card grow-1">
      <h2 className="text-md font-semibold">{name}</h2>
      {isPending ? (
        <Skeleton className="h-[24px] w-full my-[4px]" />
      ) : (
        <p className="font-semibold text-2xl text-metric-accent my-0.5">
          {isError ? (
            <span className="text-status-bad">Network Error</span>
          ) : (
            (currency ? "$" : "") + numberFmt(value || 0)
          )}
        </p>
      )}
      <Label className="text-muted-foreground font-sans font-normal">{sub}</Label>
    </div>
  )
}
